import {
  ROLE_INVOICE_DETAIL_DISPLAY,
  ROLE_INVOICE_DETAIL_MAINTAIN,
  ROLE_INVOICE_DOCUMENT_REQUIRED_DISPLAY,
  ROLE_INVOICE_DOCUMENT_REQUIRED_MAINTAIN,
  ROLE_INVOICE_EXPORT_DOCUMENT_DISPLAY,
  ROLE_INVOICE_EXPORT_DOCUMENT_MAINTAIN,
  ROLE_INVOICE_LOG_DETAIL_DISPLAY,
  ROLE_INVOICE_LOG_DOCUMENT_REQUIRED_DISPLAY,
  ROLE_INVOICE_LOG_EXPORT_DOCUMENT_DISPLAY,
  ROLE_INVOICE_LOG_REVISE_REQUEST_DISPLAY,
  ROLE_INVOICE_SEARCH_DISPLAY,
  ROLE_MASTER_DOCUMENT_REQUIRED_DISPLAY,
  ROLE_MASTER_DOCUMENT_REQUIRED_MAINTAIN,
  ROLE_MASTER_KPI_MANAGEMENT_DISPLAY,
  ROLE_MASTER_KPI_MANAGEMENT_MAINTAIN,
  ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_DISPLAY,
  ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_MAINTAIN,
  ROLE_MASTER_USER_MANAGEMENT_DISPLAY,
  ROLE_MASTER_USER_MANAGEMENT_MAINTAIN,
  ROLE_REQUEST_REVISE_APPROVE_MAINTAIN,
  ROLE_REQUEST_REVISE_CHANGE_SUMMARY_MAINTAIN,
  ROLE_REQUEST_REVISE_CREATE_MAINTAIN,
  ROLE_REQUEST_REVISE_DISPLAY,
  ROLE_REQUEST_REVISE_EDIT_MAINTAIN,
} from 'src/app/constants/app.constant';

export const environmentShared = {
  webHost: 'https://scgchem-xdoc.scg.com',
  // apiHost: 'https://scgchem-api-test.scg.com/exp-doc-dev',
  apiHost: 'https://scgchem-api.scg.com/expdoc-prd/',
  msalConfig: {
    tenantId: '5db8bf0e-8592-4ed0-82b2-a6d4d77933d4',
    tenantIdB2C: 'c65c86ae-d084-4c32-9826-9da294b606e5',
  },
};

export const environment = {
  production: true,
  development: false,
  requireAuthen: true,
  redirectUrl: 'https://scgchem-xdoc.scg.com',
  apiBase: environmentShared.apiHost + 'webapi',
  apiDoc: environmentShared.apiHost + 'document',
  apiAuth: environmentShared.apiHost + 'auth',
  manageAuth: {
    session: 1800,
    tokenSecret:
      'FOqVnI+uYi6GNBkqWKxDY+0jNYQeequOhrjcCdBmS6fvAfBMb8lJaR+cK3YHpwX0A5psZMGT4NPdFDI4s1SX7fEc7dO1M9RMs03hm4k9Bl0o0ii0KmWKazjykOv+cKQUQExL1DfO6QPBuK7a0Z4JOzDQhriP9UUyZvcaClbSbOKtObP1FdjeuV0YnhqZRZBUWJol9TERIrZKmaslXL7KVQ==',
    pageAuth: [
      {
        route: '/export-document/search-for-printing',
        auth: [ROLE_INVOICE_SEARCH_DISPLAY],
      },
      {
        route: '/export-document/search-for-printing-restore-criteria',
        auth: [ROLE_INVOICE_SEARCH_DISPLAY],
      },
      {
        route: '/export-document/so-detail',
        auth: [
          ROLE_INVOICE_DETAIL_DISPLAY,
          ROLE_INVOICE_DETAIL_MAINTAIN,
          ROLE_INVOICE_DOCUMENT_REQUIRED_DISPLAY,
          ROLE_INVOICE_DOCUMENT_REQUIRED_MAINTAIN,
          ROLE_INVOICE_EXPORT_DOCUMENT_DISPLAY,
          ROLE_INVOICE_EXPORT_DOCUMENT_MAINTAIN,
          ROLE_INVOICE_LOG_DETAIL_DISPLAY,
          ROLE_INVOICE_LOG_DOCUMENT_REQUIRED_DISPLAY,
          ROLE_INVOICE_LOG_EXPORT_DOCUMENT_DISPLAY,
          ROLE_INVOICE_LOG_REVISE_REQUEST_DISPLAY,
        ],
      },
      {
        route: '/export-document/create-revise-request',
        auth: [
          ROLE_REQUEST_REVISE_CREATE_MAINTAIN,
          ROLE_REQUEST_REVISE_CHANGE_SUMMARY_MAINTAIN,
        ],
      },
      {
        route: '/export-document/edit-revise-request',
        auth: [
          ROLE_REQUEST_REVISE_EDIT_MAINTAIN,
          ROLE_REQUEST_REVISE_CHANGE_SUMMARY_MAINTAIN,
        ],
      },
      {
        route: '/export-document/approve-revise-request',
        auth: [ROLE_REQUEST_REVISE_APPROVE_MAINTAIN],
      },
      {
        route: '/export-document/view-revise-request',
        auth: [ROLE_REQUEST_REVISE_DISPLAY],
      },
      {
        route: '/master/document-required-master',
        auth: [
          ROLE_MASTER_DOCUMENT_REQUIRED_DISPLAY,
          ROLE_MASTER_DOCUMENT_REQUIRED_MAINTAIN,
        ],
      },
      {
        route: '/master/view-document-required-master',
        auth: [ROLE_MASTER_DOCUMENT_REQUIRED_DISPLAY],
      },
      {
        route: '/master/edit-document-required-master',
        auth: [ROLE_MASTER_DOCUMENT_REQUIRED_MAINTAIN],
      },
      {
        route: '/master/create-document-required-master',
        auth: [ROLE_MASTER_DOCUMENT_REQUIRED_MAINTAIN],
      },
      {
        route: '/master/public-document-owner',
        auth: [
          ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_DISPLAY,
          ROLE_MASTER_PUBLIC_DOCUMENT_OWNER_MAINTAIN,
        ],
      },
      {
        route: '/master/user-management',
        auth: [
          ROLE_MASTER_USER_MANAGEMENT_DISPLAY,
          ROLE_MASTER_USER_MANAGEMENT_MAINTAIN,
        ],
      },
      {
        route: '/master/create-user-management',
        auth: [
          ROLE_MASTER_USER_MANAGEMENT_DISPLAY,
          ROLE_MASTER_USER_MANAGEMENT_MAINTAIN,
        ],
      },
      {
        route: '/master/edit-user-management',
        auth: [
          ROLE_MASTER_USER_MANAGEMENT_DISPLAY,
          ROLE_MASTER_USER_MANAGEMENT_MAINTAIN,
        ],
      },
      {
        route: '/master/kpi-management',
        auth: [
          ROLE_MASTER_KPI_MANAGEMENT_DISPLAY,
          ROLE_MASTER_KPI_MANAGEMENT_MAINTAIN,
        ],
      },
      {
        route: '/master/create-kpi-management',
        auth: [
          ROLE_MASTER_KPI_MANAGEMENT_DISPLAY,
          ROLE_MASTER_KPI_MANAGEMENT_MAINTAIN,
        ],
      },
      {
        route: '/master/edit-kpi-management',
        auth: [
          ROLE_MASTER_KPI_MANAGEMENT_DISPLAY,
          ROLE_MASTER_KPI_MANAGEMENT_MAINTAIN,
        ],
      },
    ],
    roles: [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24,
    ],
    defaultToken:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSJ9.eyJhdWQiOiI0YmFjNGY5ZS02ZjgzLTQ0OWItODk0NS1hZmYwNWY3YjFlMGUiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vNWRiOGJmMGUtODU5Mi00ZWQwLTgyYjItYTZkNGQ3NzkzM2Q0L3YyLjAiLCJpYXQiOjE2NjQzMzY2MzgsIm5iZiI6MTY2NDMzNjYzOCwiZXhwIjoxNjY0MzQwNTM4LCJuYW1lIjoic2t5ZmxvdyB0ZXN0MDUiLCJub25jZSI6ImY4MjMxOTAyLTMyM2YtNDFkZC04NGNhLWY1YzA0OTk4ZTg0MiIsIm9pZCI6ImQwYmM0ZDg4LWFmOGItNDAxNS1iNmUwLTVlMTU4MjhiNjFjYiIsInByZWZlcnJlZF91c2VybmFtZSI6InNreWZsb3cudGVzdDA1QHNjZy5jb20iLCJyaCI6IjAuQVZZQURyLTRYWktGMEU2Q3NxYlUxM2t6MUo1UHJFdURiNXRFaVVXdjhGOTdIZzVXQUU0LiIsInN1YiI6IlhRZ2R6d3FJMkp2SlpKdUJuZUI1VVYtcVM2ejBuRXE1X19IcWx1S3JXQWciLCJ0aWQiOiI1ZGI4YmYwZS04NTkyLTRlZDAtODJiMi1hNmQ0ZDc3OTMzZDQiLCJ1dGkiOiJVd1RDVUN1TlQwNnNkeFZWcE53R0FBIiwidmVyIjoiMi4wIn0.LUiwbgW3G3j-CQPkcHlmr5jqz-YY90THvTjgBI-qXDrWiEem6qjDtI3eFFsuFamR7uOhn4Mi165ziRM7jjnpcSudT0Ptww-2HIavayYbBhc_URf9CRGUiIuzgtvf4d3NLIYbBrUcDeoy00LcFpnMRgkvL18Xj8Gjg23G-JjZ9HWvd3i29z3mJZrNlaFK3wjaW720vRungmMycaFqKERKSstJXYnPzRSAcsLi8TcL6JwVrlsvLizEWuW9Oe23NmMzdM603LE7GyEUPuMQdioteWgH9SU10j_aZrCTaQ9Wp3d7yQ4kzmpfZfQBiPTDFIu1FRDDJNOacmmefcYDES3UfQ',
    defaultUser: {
      name: 'Firstname Lastname',
      userName: 'firstname.lastname@scg.com',
    },
    loginUrl: environmentShared.webHost + '/',
    redirectToCommon: true,
    defaultAppToken: '',
  },
  apiUrl: {
    authorizationService: environmentShared.apiHost + '/authorization/api/',
  },
  msalConfig: {
    clientId: '69eff6e3-ee62-43bc-8f21-49e236e98e69',
    authorityUrl:
      'https://login.microsoftonline.com/' +
      environmentShared.msalConfig.tenantId,
    redirectUri: environmentShared.webHost + '/',
    graphUrl: 'https://graph.microsoft-ppe.com/v1.0/me',
    tenantId: environmentShared.msalConfig.tenantId,
    // B2C
    clientIdB2C: '7c0d6209-3651-4d98-bc74-87d218852212',
    // authorityUrlB2C:
    //   'https://login.microsoftonline.com/' +
    //   environmentShared.msalConfig.tenantIdB2C,
    authorityUrlB2C:
      'https://scgchemb2c.b2clogin.com/scgchemb2c.onmicrosoft.com/',
    redirectUriB2C: environmentShared.webHost + '/',
    graphUrlB2C: 'https://graph.microsoft-ppe.com/v1.0/me',
    tenantIdB2C: environmentShared.msalConfig.tenantIdB2C,
    authorityDomainB2C: 'scgchemb2c.b2clogin.com',
    signUpSignInB2C: 'B2C_1_EXP_Sign-in',
    editProfileB2C: 'b2c_1_edit_profile_v2',
    resetPasswordB2C: 'B2C_1_EXP_reset-password-flow',
  },
  apimConfig: {
    apimFlag: true,
    apimSubscriptionKey: 'ba6b1749c1cf423bba53d4cc90c4abcd',
    caller: 'Client',
    callerB2C: 'Client_B2C',
  },
  envVersion: 'PROD',
  linkForUserManualPDF:
    'https://expdocblobmanualprd.blob.core.windows.net/manual/xDocUserManual.pdf',
  linkCreateAccount:
    'https://scgchemb2c.b2clogin.com/scgchemb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_EXP_Sign-UP_flow&client_id=7c0d6209-3651-4d98-bc74-87d218852212&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fscgchem-xdoc.scg.com%2F&scope=openid&response_type=code&prompt=login&code_challenge_method=S256&code_challenge=Nk4AC8OrOO1Id_WuQvdOdOjeyeNgETk0GVrRS_D_oA4',
};
